import { Box, Typography } from '@mui/material';
import React from 'react';
import PAGE_EMPTY from '../../assets/svg/page-empty.svg';

interface EmptyStateProps {
  title: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title }) => {
  return (
    <Box height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap="40px">
      <img src={PAGE_EMPTY} width={240} height={240} alt="user" />
      <Typography color="#98A2B3" fontWeight={500} fontSize="16px" lineHeight="24px" textAlign="center">
        {title}
      </Typography>
    </Box>
  );
};

export default EmptyState;
